export enum AccessRestrictionEnum {
  NONE = 0,
  ONLY_SMALL_TRUCKS = 1,
  ONLY_MW = 2,
}
